import * as Types from '../constants/actionTypes';
const initState = {
  requestTypesList: [],
  requestDetails:[],
  error: null
}
export default (state = initState, action) => {
  switch (action.type) {
    case Types.MASTER_REQUEST_TYPES_SUCCESS:
      return {
        ...state,
        requestTypesList: action.payload.data,
        requestDetails: action.payload.requestData
      }
    case Types.MASTER_REQUEST_TYPES_COUNT_SUCCESS:
      return {
        ...state,
        requestTypesListCount: action.payload
      }
    case Types.MASTER_REQUEST_TYPES_ERROR:
      return {
        ...state,
        requestTypeError: action.payload
      }
    case Types.MASTER_ADD_REQUEST_TYPES_SUCCESS:
      return {
        ...state,
        requestTypesList: [...state.requestTypesList, action.payload]
      }
    case Types.MASTER_DELETE_REQUEST_TYPES_SUCCESS:
        return {
          ...state,
          requestTypesList: state.requestTypesList.filter(item => item.id !== action.payload.id)
        }
    case Types.MASTER_UPDATE_REQUEST_TYPES_SUCCESS:
      let changedIndex = state.requestTypesList.findIndex(item => item.id === action.payload.id);
      const newRequestTypesList = Object.assign([], state.requestTypesList);
      if (changedIndex > -1) {
        newRequestTypesList[changedIndex] = action.payload;
      }
      return {
          ...state,
          requestTypesList: newRequestTypesList
      }
    default:
      return state;
  }
};
